import { render } from "./NewPerson.vue?vue&type=template&id=60646673&scoped=true"
import script from "./NewPerson.vue?vue&type=script&lang=js"
export * from "./NewPerson.vue?vue&type=script&lang=js"

import "./NewPerson.vue?vue&type=style&index=0&id=60646673&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60646673"]])

export default __exports__